export class InitialGradeSource {
    grade;
    source;
    constructor(grade, source = null) {
        this.grade = grade;
        this.source = source;
    }
    get id() {
        return this.grade.id;
    }
    get title() {
        return this.grade.title;
    }
}
